import { forwardRef, createElement } from 'react';

function IconConnectionRevoke(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M16.66 4.174a.75.75 0 01.32.933l-.045.091-8.298 14.373a.75.75 0 01-1.344-.659l.045-.091 8.298-14.373a.75.75 0 011.025-.274zM5 9a3.001 3.001 0 012.935 2.374.685.685 0 01.169-.02h1.814l-.866 1.5h-.948a.75.75 0 01-.22-.033A2.998 2.998 0 012 12a3 3 0 013-3zm14 0a3 3 0 11-2.877 3.854h-1.875l.866-1.5.956-.001A3.001 3.001 0 0119 9zM5 10.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm14 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    fill: "currentColor"
  }));
}

var ConnectionRevoke = /*#__PURE__*/forwardRef(IconConnectionRevoke);

export default ConnectionRevoke;
//# sourceMappingURL=ConnectionRevoke.js.map
